// extracted by mini-css-extract-plugin
module.exports = {"life_style":"styles_life_style__fE6_0","card":"styles_card___PJtG","card__image":"styles_card__image__TrOPE","category_card__content":"styles_category_card__content__dydTy"};